import auth0 from 'auth0-js';
import { AUTH_CONFIG, LOGOUT_RETURN_URL } from '../../config';

export function getWebAuth() {
  return new auth0.WebAuth({
    domain: AUTH_CONFIG.domain,
    clientID: AUTH_CONFIG.clientId,
    redirectUri: AUTH_CONFIG.callbackUrl,
    audience: AUTH_CONFIG.audience,
    responseType: 'token id_token',
    scope: 'openid email'
  });  
}

export function authorize() {
  try {
    getWebAuth().authorize();
  } catch (error) {
    console.log("authorize error", error);
  }
}

export function checkAuth() {
  return new Promise((resolve, reject) => {
    getWebAuth().parseHash(function(err, authResult) {
      if (authResult && authResult.accessToken && authResult.idToken) {
        setSession(authResult);
        resolve({success: true});
      } else if (err) {
        resolve({failure: err.errorDescription});
      }
    });      
  })
}

export function getDecodedToken() {
  if (!isAuthenticated()) {
    return [];
  }
  const token = getAccessToken();
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  return JSON.parse(window.atob(base64));
}
export function getScopes(decodedToken) {
  if (!isAuthenticated()) {
    return [];
  }
  
  return decodedToken.scope.split(" ");
}
export function getUserMetadata(decodedToken) {
  if (!isAuthenticated()) {
    return "";
  }
  
  return decodedToken[AUTH_CONFIG.defaultDashboardKey];
}

function setSession(authResult) {
  // Set the time that the access token will expire at
  let expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
  localStorage.setItem('access_token', authResult.accessToken);
  localStorage.setItem('id_token', authResult.idToken);
  localStorage.setItem('expires_at', expiresAt);
  // navigate to the home route
  // history.replace('/home');
}

export function logout() {
  // Clear access token and ID token from local storage
  localStorage.removeItem('access_token');
  localStorage.removeItem('id_token');
  localStorage.removeItem('expires_at');

  // navigate to the home route
  try {
    getWebAuth().logout({
      returnTo: LOGOUT_RETURN_URL,
      clientID: AUTH_CONFIG.clientId
    })
  } catch (error) {
    console.log("logout error", error)
  }
  // history.replace('/home');
}

export function isAuthenticated() {
  // Check whether the current time is past the 
  // access token's expiry time
  let expiresAt = JSON.parse(localStorage.getItem('expires_at'));
  return new Date().getTime() < expiresAt;
}

export function getAccessToken() {
  return localStorage.getItem("access_token");
}